import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getDatabase } from "firebase/database";
// Import the functions you need from the SDKs you need
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDD5KQ16QGC9oU5NsUm-LQNd_PtnOy84qU",
  authDomain: "waiting-list-easy.firebaseapp.com",
  projectId: "waiting-list-easy",
  storageBucket: "waiting-list-easy.firebasestorage.app",
  messagingSenderId: "47425390859",
  appId: "1:47425390859:web:4215cf19b2509e48e07a0e",
  measurementId: "G-XERCSHRRYJ"
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const provider = new GoogleAuthProvider()
const db = getDatabase(app)

export { auth, provider, db };
